import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "./cn";

/** The mock's constellation, drawn when a screen has nothing to show yet. */
function Constellation() {
  return (
    <svg viewBox="0 0 132 72" aria-hidden className="mx-auto mb-3.5 block h-[72px] w-[132px]">
      <path
        d="M12 54 38 22 70 30 96 12 120 40 84 60"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        opacity=".55"
      />
      <circle cx="12" cy="54" r="3" fill="currentColor" />
      <circle cx="38" cy="22" r="2.5" fill="currentColor" />
      <circle cx="70" cy="30" r="4" className="fill-gold" />
      <circle cx="96" cy="12" r="2.5" fill="currentColor" />
      <circle cx="120" cy="40" r="3" fill="currentColor" />
      <circle cx="84" cy="60" r="2.5" fill="currentColor" />
    </svg>
  );
}

/** An empty screen that points to the next action. */
export function EmptyState({
  icon: Icon,
  title,
  text,
  action,
  className,
}: {
  icon?: LucideIcon;
  title: ReactNode;
  text?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("px-5 py-12 text-center text-ink-2", className)}>
      <div className="text-ink-3">
        {Icon ? <Icon aria-hidden className="mx-auto mb-3.5 size-10" /> : <Constellation />}
      </div>
      <h3 className="mb-1 text-md text-ink">{title}</h3>
      {text && <p className="mx-auto mb-4 max-w-[46ch]">{text}</p>}
      {action}
    </div>
  );
}
